import CoursewareCollapsibleBox from './layouts/CoursewareCollapsibleBox.vue';
import CoursewareCompanionBox from './layouts/CoursewareCompanionBox.vue';
import CoursewareDefaultBlock from './blocks/CoursewareDefaultBlock.vue';
import CoursewareDefaultContainer from './containers/CoursewareDefaultContainer.vue';
import CoursewareFileChooser from './layouts/CoursewareFileChooser.vue';
import CoursewareTabs from './layouts/CoursewareTabs.vue';
import CoursewareTab from './layouts/CoursewareTab.vue';

const CoursewarePluginComponents = {
    CoursewareCollapsibleBox,
    CoursewareCompanionBox,
    CoursewareDefaultBlock,
    CoursewareDefaultContainer,
    CoursewareFileChooser,
    CoursewareTabs,
    CoursewareTab,
}

export default CoursewarePluginComponents;
